<template>
  <section
    data-qa="legal_case_banner"
    class="legal-case-banner border-radius-sm position-relative overflow-hidden pa-6 mb-4"
    :class="isMobile ? 'legal-case-banner__mobile' : 'legal-case-banner__desktop'"
  >
    <span class="legal-case-banner__overlay_darken position-absolute" />
    <div class="d-flex justify-space-between flex-wrap gr-4">
      <div
        v-for="(info, index) in bannerInfo"
        :key="index"
        class="d-flex align-center position-relative text-body-1 bg-gray-0--text mr-2"
      >
        <v-icon
          width="22px"
          height="22px"
          class="bg-gray-0--text"
        >
          {{ info.icon }}
        </v-icon>
        <div
          data-qa="legal_case_banner_text"
          class="pl-4"
        >
          {{ info.text }}
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import declensionByNum from 'src/utils/declensionByNum'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  wonCases: number,
  completedCases: number,
  courthearingCount: number,
  duringCases: number,
  isMobile: boolean,
}>()

const bannerInfo = [
  {
    icon: 'ui-icon-thumbs-up-empty',
    text: `${t('Выиграли', options)} ${props.wonCases} ${t('из', options)} ${props.completedCases} ${declensionByNum(props.wonCases, ['дело', 'дела', 'дел'])}`,
  },
  {
    icon: 'ui-icon-shield',
    text: `${t('Участвовали в', options)} ${props.courthearingCount} ${t('заседаниях', options)}`,
  },
  {
    icon: 'ui-icon-shuffle',
    text: `${t('Ждем решений по', options)} ${props.duringCases} ${declensionByNum(props.duringCases, ['делу', 'делам', 'делам'])}`,
  },
]
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.legal-case-banner__overlay_darken {
  background: rgba(54, 54, 54, 0.6);
  inset: 0;
}

.legal-case-banner {
  background-position: center;
  background-size: cover;
  box-sizing: border-box;

  &__desktop {
    background-image: url('/static/_v1/pd/banners/legal-case-banner.jpg');
    border: 1px solid $ui-kit-bg-gray-0;
  }

  &__mobile {
    background-image: url('/static/_v1/pd/banners/legal-case-banner-mobile.jpg');
  }
}
</style>
